
declare let gtag: any;

export class GoogleAnalyticsService {
  public eventEmitter(
    eventName: string,
    eventCategory: string,
    eventLabel: string,
    eventAction: string,
    eventValue: number = null ) {
    gtag('event', eventName, {
      event_category: eventCategory,
      event_action: eventAction,
      event_label: eventLabel,
      value: eventValue
    });
  }
}
